<form [formGroup]="formGroup">
    <div class="profile-data-form m-t-30">
        <!-- USER CREDENTIALS ROW -->
        <div class="d-flex g-15">

            <!-- USERNAME -->
            @if(user) {
            <mat-form-field class="full-width input-regular element-disabled" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.username' | translate }}</mat-label>
                <input class="cursor-disabled-gray" type="text" matInput formControlName="username"
                    id="input-username" [readonly]="true" autocomplete="new-username">
            </mat-form-field>
            } @else {
            <mat-form-field class="full-width input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.username' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('username')" [ngClass]="{'icon' : formGroup.get('username')?.value, 
                        'd-none': !formGroup.get('username')?.value}"></fa-icon>

                <input type="text" matInput formControlName="username" id="input-username">

                @if (formGroup.controls['username'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{'configuration-page.action-dialog.username-required' | translate }}
                </mat-error>
                }
            </mat-form-field>
            }

            <!-- PASSWORD -->
            <mat-form-field class="full-width input-regular" appearance="outline" subscriptSizing="dynamic">
                <mat-label>{{ 'configuration-page.action-dialog.password' | translate }}</mat-label>
                <input [type]="inputTypePassword" matInput formControlName="password" id="input-password"
                    [errorStateMatcher]="matcher" autocomplete="new-password">

                @if( inputTypePassword === 'password'){
                <fa-icon (click)="toogleInputPassword('inputPassword', 'text')" class="icon icon-password" id="icon-eye"
                    [icon]="['fal', 'eye']"></fa-icon>
                }@else {
                <fa-icon (click)="toogleInputPassword('inputPassword','password')" class="icon icon-password"
                    id="icon-eye-slash" [icon]="['fal', 'eye-slash']"></fa-icon>
                }

                <!-- VALIDATIONS -->
                @if (formGroup.controls['password'].hasError('required')) {
                <mat-error id="text-error-required-input">
                    {{'configuration-page.action-dialog.password-required' | translate }}</mat-error>
                }
                @if (formGroup.controls['password'].hasError('pattern')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.error-uppercase' | translate
                    }}</mat-error>
                }
                @if (formGroup.controls['password'].hasError('numeric')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.error-numeric' | translate }}</mat-error>
                }
                @if (formGroup.controls['password'].hasError('alphaNumeric')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.error-alphanumeric' | translate
                    }}</mat-error>
                }

                @if (formGroup.controls['password'].hasError('minlength')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.min-length' | translate }}</mat-error>
                }
                @if (formGroup.controls['password'].hasError('lowercase')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.error-lowercase' | translate
                    }}</mat-error>
                }
                @if (formGroup.controls['password'].hasError('user-error')) {
                <mat-error id="text-error-pattern-input">{{ 'set-password.form.user-error' | translate }}</mat-error>
                }
            </mat-form-field>

            <!-- REPEAT PASSWORD -->
            <mat-form-field class="full-width input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.repeat-password' | translate }}</mat-label>
                <input [type]="inputTypeRepeatPassword" matInput formControlName="repeatPassword"
                    id="input-repeatPassword">

                @if( inputTypeRepeatPassword === 'password'){
                <fa-icon (click)="toogleInputPassword('inputRepeatPassword', 'text')" class="icon icon-password"
                    id="icon-eye" [icon]="['fal', 'eye']"></fa-icon>
                }@else {
                <fa-icon (click)="toogleInputPassword('inputRepeatPassword','password')" class="icon icon-password"
                    id="icon-eye-slash" [icon]="['fal', 'eye-slash']"></fa-icon>
                }

                <!-- VALIDATIONS -->
                @if (formGroup.controls['repeatPassword'].hasError('required')) {
                <mat-error id="text-error-input">
                    {{ 'configuration-page.action-dialog.password-repeat-required' | translate }}
                </mat-error>
                }
                @if (!formGroup.controls['repeatPassword'].hasError('required') &&
                formGroup.controls['repeatPassword'].hasError('confirmedValidator')) {
                <mat-error id="text-error-required-input"> {{ 'set-password.form.error-same' | translate }}
                </mat-error>
                }
            </mat-form-field>
        </div>

        <!-- USER PERSONAL INFORMATION ROW -->
        <div class="d-flex g-15">

            <!-- USER PRONOUN-->
            <mat-form-field class="w-per-20 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.pronoun' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="pronounSelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="pronounType" multiple matNativeControl panelClass="panel-multi-select"
                    id="pronounType" #pronounSelected>
                    @for (pronoun of pronounsTypes; track pronoun) {
                    <mat-option class="panel-mat-option" [value]="pronoun.id" [id]="pronoun.id"
                        (click)="propagateCheck(pronoun.id, 'pronounType')">
                        <mat-checkbox [color]="'primary'" [id]="pronoun.id" [value]="pronoun.id"
                            [checked]="isChecked(pronoun.id, 'pronounType')">
                            {{ pronoun.description }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- USER NAME-->
            <mat-form-field class="w-per-40 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.firstname' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('firstName')" [ngClass]="{'icon' : formGroup.get('firstName')?.value,
                    'd-none': !formGroup.get('firstName')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="firstName" id="input-firstName" autocomplete="off">

                @if (formGroup.controls['firstName'].hasError('required')) {
                <mat-error id="text-error-required-input">
                    {{ 'configuration-page.action-dialog.name-required' | translate }}
                </mat-error>
                }
            </mat-form-field>

            <!-- USER LASTNAME-->
            <mat-form-field class="w-per-40 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.lastname' | translate | capitalize }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('lastName')" [ngClass]="{'icon' : formGroup.get('lastName')?.value,
                    'd-none': !formGroup.get('lastName')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="lastName" id="input-lastName" autocomplete="off">

                @if (formGroup.controls['lastName'].hasError('required')) {
                <mat-error id="text-error-required-input">
                    {{'configuration-page.action-dialog.lastname-required' | translate }}
                </mat-error>
                }
            </mat-form-field>

        </div>

        <!-- USER OTHERS ROW -->
        <div class="d-flex g-15">

            <!-- USER SPECIALTY -->
            <mat-form-field class="w-per-40 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.specialty' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="specialtySelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="specialityId" multiple matNativeControl panelClass="panel-multi-select"
                    id="specialty" #specialtySelected>
                    @for (specialty of specialties; track specialty) {
                    <mat-option class="panel-mat-option" [value]="specialty.specialityId" [id]="specialty.specialityId"
                        (click)="propagateCheck(specialty.specialityId, 'specialityId')">
                        <mat-checkbox [color]="'primary'" [id]="specialty.specialityId" [value]="specialty.specialityId"
                            [checked]="isChecked(specialty.specialityId, 'specialityId')">
                            {{ specialty.description }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- USER CATEGORY -->
            <mat-form-field class="w-per-40 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.category' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="categorySelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="category" multiple matNativeControl panelClass="panel-multi-select"
                    id="category" #categorySelected>
                    @for (category of categories; track category) {
                    <mat-option class="panel-mat-option" [value]="category" [id]="category"
                        (click)="propagateCheck(category, 'category')">
                        <mat-checkbox [color]="'primary'" [id]="category" [value]="category"
                            [checked]="isChecked(category, 'category')">
                            {{ category }}
                        </mat-checkbox>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <!-- USER EXTERNAL CODE-->
            <mat-form-field class="w-per-30 input-regular" appearance="outline" #tooltip="matTooltip"
                matTooltip="{{ 'configuration-page.tooltips.navision-code' | translate }}">
                <mat-label>{{ 'configuration-page.action-dialog.external-code' | translate }}</mat-label>
                <fa-icon [icon]="['fal', 'xmark']" (click)="clearInput('externalId')" [ngClass]="{'icon' : formGroup.get('externalId')?.value,
                        'd-none': !formGroup.get('externalId')?.value}">
                </fa-icon>

                <input type="text" matInput formControlName="externalId" id="input-externalId" autocomplete="off">
            </mat-form-field>
        </div>

        <div class="d-flex g-15">
            <!-- USER LANGUAGE -->
            <mat-form-field class="w-per-30 input-regular" appearance="outline">
                <mat-label>{{ 'configuration-page.action-dialog.language' | translate }}</mat-label>
                <div matSuffix style="padding-left: 20px;">
                    <fa-icon [icon]="['fal','angle-down']" [rotate]="languageSelected?.panelOpen ? 180 : undefined"
                        class="font-16 chevron-icon"></fa-icon>
                </div>
                <mat-select formControlName="langId" multiple matNativeControl panelClass="panel-multi-select"
                    id="language" #languageSelected>
                    @for (language of languagesTypes; track language) {
                    <mat-option class="panel-mat-option" [value]="language.langId" [id]="language.langId"
                        (click)="propagateCheck(language.langId, 'langId')">
                        <mat-checkbox [color]="'primary'" [id]="language.langId" [value]="language.langId"
                            [checked]="isChecked(language.langId, 'langId')">
                            {{ language.description }}
                        </mat-checkbox>
                    </mat-option>
                    }

                </mat-select>
            </mat-form-field>

        </div>

        @if(context !== actionContextEnum.PROFILE) {
        <!-- USER ADMIN TOOGLE ROW -->
        <div class="user-admin-row d-flex g-5 align-item-center">
            <input type="checkbox" formControlName="admin" id="adminToogleCheckbox">
            <label for="adminToogleCheckbox" class="admin-toogle-checkbox-label">{{
                'configuration-page.action-dialog.isAdmin' | translate }}</label>

        </div>
        }

    </div>

</form>